import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { CommandController } from '@shared/src/controllers/internal/command/command.controller';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';


@Component({
    selector: 'shared-command-component',
    templateUrl: './shared.command.component.html',
    styleUrls: ['./shared.command.component.scss'],
})
export class SharedCommandComponent implements OnInit {
    public command: string;
    public actions: ActionsStripDto;
    public cosesAnteriors: CosesAnteriors[] = [];
    @ViewChild('scrollMessages', { static: true }) private scrollMessagesContainer: ElementRef;

    constructor(protected commandController: CommandController) {

    }

    onClickAction($event: ActionDto) {
        if ($event.actionId === "CLEAR") {
            this.actions = new ActionsStripDto();
        }
    }

    ngOnInit(): void {
        this.cosesAnteriors = [];
        this.actions = new ActionsStripDto();
        this.actions.add(ActionDto.build("CLEAR", "COMMOND.CLEAR.CAPTION", "COMMOND.CLEAR.HELP", "", 10, -1, 0, ""))
    }

    public executeCommand() {
        this.commandController.postCommand(this.command).subscribe(e => {
            this.command = "";
            if (e != null)
                e.steps.forEach(x => {
                    this.cosesAnteriors.push(CosesAnteriors.build(x.type, x.text));
                    if (x.type === 'openlink' && x.text)
                        window.open(x.text, '_blank');
                });
        });
    }

    public textareakeypress(e) {
        var code = (e.keyCode ? e.keyCode : e.which);
        if (!e.shiftKey && code == 13) { //Enter keycode
            e.preventDefault();
            this.executeCommand();
        }
    }
    doSomethingOnScroll($event: any) {
        let scrollOffset = $event.srcElement.scrollTop;
        //Si estem al inici recarreguem mes missatges
        if (scrollOffset == 0) {
        }
    }

    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}


export class CosesAnteriors {
    public type: string;
    public text: string;

    public static build(type: string, text: string): CosesAnteriors {
        let result: CosesAnteriors = new CosesAnteriors();
        result.type = type;
        result.text = text;
        return result;
    }
}